<template>
	<ppe-form 
		entityName="B3"
	  formkey="b3_eu"
		title="B3. Livret d'Accueil Prévention" 
		title-field="{company.name}"
 	  sub-title=""

		:schema="schema" 
		:endpoint="endpoint"
		:redirect="'/ppe_eu/home/:accountid'" 
		v-on:dataLoaded="onDataLoaded"
		>

	</ppe-form>
</template>
<script>
 
import Business from 'ppe-business'
import Utils    from '../ppe/utils'

export default {
	data() {
		var self = this;
		console.log("this.$route.params.operationid", this.$route.params.operationid)
		return {
			endpoint : "/eu/b3?id="+this.$route.params.id+"&companyid="+this.$route.query.companyid,
			dangers: {},
			schema : [
				// A cacher
				/*{ card:"Analyse des principaux dangers",
					body:[
						{name:"mainDangers",       label:'',         type:"checkboxtable", displayIndex:true,  size:'large',
								columns: ['#','', 'PRINCIPAUX DANGERS','CAUSES / CONSEQUENCES POTENTIELLES','MESURES DE PRÉVENTION'],
								options:[ 
									{value:'md1', label:"Coactivité / interactivité", suffixValues:['intervention du personnel d’autres entreprises， travaux en superposition', 'informer les intervenants lors de la Visite d’Inspection Commune et contrôler leur PPSPS avant leur intervention'] }, 
									{value:'md2', label:'Déchargement de véhicules', suffixValues:['Ecrasement， port de charges， Troubles musculo- squelettiques', 'respecter le Protocole de Sécurité， le Plan de Circulation， la limitation de vitesse， le balisage de la zone occupée.'] },
									{value:'md3', label:"Chute de hauteur", suffixValues:['Travail en hauteur， contusions， fractures， traumatismes irréversibles', 'port du harnais obligatoire， contrôle de l’habilitations des intervenants aux tâches à effectuer， balisage au sol'] }, 
									{value:'md4', label:'Chute d’objets', suffixValues:['chute d’éléments de construction， de matériel， d’outillage et de matériaux', 'mettre en place un balisage au sol ， interdire l’accès pendant les périodes de levage ou de manutention méca'] },
									{value:'md5', label:"Chute de plain-pied", suffixValues:['Sol glissant / irrégulier， caniveau， quai de déchargement， marches， faux plancher', 'Poser des goulottes sur les connecteurs mobiles， ranger， baliser et éclairer stockages， porter chaussures sécurité'] }, 
								]
						}
					],
				},*/
				
				{ card:"Dangers et risques liés à la spécificité de l'environnement biologique", cardkey:"b3_card_biologique",
					body:[
						{component:"div", children:[
						{component:'label-editable', resourcekey:'b3_card_biologique_rq', text:"Seul le respect des mesures de préventions permet de limiter les risques d’infection"}
						], size:"large"},
						{name:"covidDangers",       label:'',         type:"checkboxtable", displayIndex:true,  size:'large',
								columns: ['#','', 'RISQUES COVID','CAUSES / CONSEQUENCES POTENTIELLES','GESTES BARRIERES DE PRÉVENTION'],
								options: Business.covidDangers
						},
						{component:'h3', children:"Il faut limiter la coactivité en réorganisant les opérations", size:"large"},
						{component:'p', children:"Les personnels doivent d’abord appliquer les mesures édictées par leur Entreprise, et seulement après prendre en compte les mesures préconisées par l’Entreprise Utilisatrice, dont celles propres aux virus et bactéries environnantes qui pourraient être rencontrées, dans certaines zones du site.", size:"large"},
					],
				},

				{ card:"Analyse des dangers et des risques récurrents", cardkey:"b3_card_reccurrentDangers",
				  id:'risks',
					body:[
					  {component:"div", style:"color:red", size:"large", children:[
							{component:'label-editable', resourcekey:'b3_card_reccurrentDangers_rq', text:"Remarque: Les modifications faites ici, se reporteront sur les D3. LAP Livret d'Accueil Prévention de toutes vos opérations"} ]},
						{name:"reccurrentDangers",       label:'',         type:"checkboxtable", displayIndex:true,  size:'large',
								columns: ['#','', 'RISQUES RECURRENTS','CAUSES / CONSEQUENCES POTENTIELLES','MESURES DE PRÉVENTION'],
								options:Business.reccurrentDangers,
						},
					],
				},
				// A masquer pour les EE ?
				{ card:"Procédures particulières", cardkey:"b3_card_special_procedures",
					body:[
						{name:"meetingPoint",      label:"Le point de rassemblement des personnels est situé :",    type: "textarea",  
							placeholder:"Indiquer le lieu où se trouve le point de rassemblement",  size:'large', 
							help:"Le comptage du personnel sera fait par les responsables de services, chefs d’équipe, coordinateurs…"},
						{name:"preInterventionProcedures", label:"Procédures à appliquer avant intervention", type:"checkboxtable", size:"large",
							options:Business.preInterventionProcedures,
						},
						{name:"specificAuthorizations", label:"Autorisations particulières", type:"checkboxtable", size:"large",
							options:Business.specificAuthorizations
						},
						{name:"EPI", label:"Equipements de Protection Individuelle à utiliser", type:"checkboxtable", size:"large",
							options:[
								{value:'epi1', label:"Casque， lunettes， chaussures de sécurité"},
								{value:'epi2', label:"Gants adaptés au risque (mécanique， chimique， thermique)"},
								{value:'epi3', label:"Bottes anti-acide / combinaison anti acide"},
								{value:'epi4', label:"Masque à air- type de cartouche"},
								{value:'epi5', label:"Protections auditives : bouchons d’oreille…"},
								{value:'epi6', label:"Harnais"},
								{value:'epi7', label:"Marquage vêtement de Travail au nom de l’EE /Port badge Identification"},
								]
						},
						{name:"specialAuthorisations", label:"Autorisations spéciales à produire", type:"checkboxtable", size:"large",
							options:Business.specialAuthorisations
						},
						

					]
				},
				Utils.getGetManagerCard(),
				Utils.getAdminCard(),
				
				],
		}
	},
	methods : {
		/*ParentHasDanger(danger) {
			console.log("ParentHasDanger", danger, this.dangers)
			//return this.reccurrentDangersParent && this.reccurrentDangersParent.includes(danger) ? ["☑"]:["☐"]

			return this.dangers ? this.dangers[danger] : ''
		},*/
		onDataLoaded(data) {
			
		}
	}
};
</script>
<style>
.display-inline {
	display:   flex;
	flex-wrap: wrap;
}

.formulate-input-element-checkboxtable .formulate-input-label {
	/*white-space:nowrap;*/
	min-width: 40%;
}
</style>
